<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="DED">For Mama Jean, who wouldn’t have it any other way</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?f4312200